module.exports = __webpack_public_path__ + "img/5.db91cf86.jpg";